import { ApplicationRef } from '@angular/core';

import { bootstrapApplication } from '@angular/platform-browser';

import { loadAppEnvironment } from '@gde-mit/angular-core';

import { App } from './app/app';
import { createAppConfig } from './app/app.config';
import { ENVIRONMENT } from './environments/environment';

/**
 * Bootstrap the standalone application
 *
 * @returns The application reference
 */
async function bootstrap(): Promise<ApplicationRef> {
  await loadAppEnvironment(ENVIRONMENT, ENVIRONMENT.APP_CONFIG_PATH);

  if (ENVIRONMENT.USE_MOCK) {
    const { worker } = await import('./app/mocks/browser');

    await worker.start({
      serviceWorker: {
        url: '/mockServiceWorker.js',
      },
      onUnhandledRequest: 'bypass',
    });
  }

  return bootstrapApplication(App, createAppConfig());
}

bootstrap().catch((error) => console.error(error));
